import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import "./Breakdown.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import PowerIcon from '@material-ui/icons/Power';
import { attendBreakDown, getBDStatus, getBreakdowns, getUserReadable } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { convertUTCtoIST } from '../../helpers/DateConvert';

const CurrentBreakdown = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
    ];
    const [loading, setLoading] = useState(true);
    const [isAttendingBreakdown, setIsAttendingBreakdown] = useState(false);
    const [BDStatus, setBDStatus] = useState();
    const [breakDowns, setBreakdowns] = useState([]);
    const [userId, setUserId] = useState();
    const [userName, setUserName] = useState();
    const Role = localStorage.getItem("userRole");

    const getPriorityClass = (priority) => {
        switch (priority.toLowerCase()) {
            case 'high':
                return 'high-priority';
            case 'medium':
                return 'medium-priority';
            case 'low':
                return 'low-priority';
            default:
                return '';
        }
    };


    const handler = async (asset) => {
        if (Role === 'admin' || Role === 'supplier') {
            if (asset.status === "reported") {
                setIsAttendingBreakdown(true);
                const payload = {
                    machine_breakdown_id: asset.id,
                    status_id: BDStatus, //under-maintanance status
                    observation: `Attended by ${userName}`,
                    customer_id: "af33f9117ecb4d8d8def84d6331eebd4",

                    //comment the approvers as it automatically add this user in the approver list(17-01-25)
                    // approvers: [{
                    //     approval_user: userId
                    // }]
                }
                console.log("payload:", payload)
                try {
                    const action = dispatch(attendBreakDown(payload));
                    const res = await action.unwrap();
                    console.log("res", res.result)
                    if (res.result) {
                        setIsAttendingBreakdown(false);
                        toast.success("BreakDown Attended Successfully!");
                        navigate(`/attend-breakdown/${asset.id}/${asset.machine_details.id}`)
                    }
                } catch (error) {
                    setIsAttendingBreakdown(false);
                    console.error("Error in okHandler:", error);
                    toast.error(error.message || "Something went wrong!");
                }
            } else {
                navigate(`/attend-breakdown/${asset.id}/${asset.machine_details.id}`)

            }
        } else {
            toast.info("You don't allow to do this activity!")
        }



    }

    const getBreakDowns = async (id) => {
        try {
            const action = dispatch(getBreakdowns(`?status_id=${id}`));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdowns(prevBreakDowns => [...prevBreakDowns, ...res.result.breakdowns]);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            // toast.info(error.message || "Something went wrong!");
        }
    };

    const getStatus = async () => {
        try {
            const action = dispatch(getBDStatus());
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {

                // Find the id for status "reported"
                const reportStatus = res.result.bd_status.find(item => item.status === "reported");
                const reportStatusId = reportStatus ? reportStatus.id : null;

                // Find the id for status "under-maintenance"
                const mainStatus = res.result.bd_status.find(item => item.status === "under-maintenance");
                const mainStatusId = mainStatus ? mainStatus.id : null;
                setBDStatus(mainStatusId)

                if (reportStatusId) {
                    await getBreakDowns(reportStatusId)
                    await getBreakDowns(mainStatusId)
                }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    const UserReadeable = async () => {
        try {
            const action = dispatch(getUserReadable());
            const res = await action.unwrap();
            console.log("res", res.result.user.customerId)
            if (res.result) {
                setUserId(res.result.user.id)
                setUserName(res.result.user.username)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }



    // useEffect(() => {
    //     const fetchData = async () => {
    //         await getStatus();
    //         await UserReadeable();
    //         setLoading(false);
    //     };
    //     fetchData();
    // }, [])

    useEffect(() => {
        let isMounted = true;  // Track if the component is still mounted

        const fetchData = async () => {
            try {
                UserReadeable();
                await getStatus();

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        // Cleanup function to prevent state update on unmounted component
        return () => {
            isMounted = false;
        };
    }, []);



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }


    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Current Breakdowns
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Current Breakdowns" />
                </Box>
                {isAttendingBreakdown ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100vh"
                        position="fixed"
                        top="0"
                        left="0"
                        width="100%"
                    // bgcolor="rgba(0, 0, 0, 0.5)"
                    >
                        <Box display="flex" alignItems="center" flexDirection="row" gap={3}>
                            {/* <CircularProgress /> */}
                            <Typography variant="h4">
                                Attending Breakdown...
                            </Typography>
                        </Box>
                    </Box>
                ) : (
                    <Box mb={2}>
                        {breakDowns.length === 0 ? (
                            <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                                <PowerIcon style={{ fontSize: 40, marginRight: 8 }} />
                                <Typography variant="h5">No Current Breakdown</Typography>
                            </Box>
                        ) : (<Grid container spacing={4}>
                            {breakDowns && breakDowns.map((item, index) => (
                                <Grid item xs={12} sm={3} key={index} onClick={() => handler(item)}>
                                    <div className='breakdown-card'>
                                        <div className={`card-header ${getPriorityClass(item.priority)}`}>
                                            <span>
                                                <PowerIcon />
                                            </span>
                                            {item.machine_details.asset_text} ({(item.machine_details.asset_no).slice(3)})
                                        </div>
                                        <h4>{item.machine_details.asset_text}</h4>
                                        <p><span>Category:</span> {item.reason.category_name}</p>
                                        <p><span>Reason:</span> {item.reason.name}</p>
                                        <p><span>Priority:</span> {item.priority}</p>
                                        <p><span>Status:</span> {item.status}</p>
                                        <p><span>Reported by:</span> {item.reported_by}</p>
                                        <p><span>Reported at:</span> {convertUTCtoIST(item.reported_at)}</p>
                                        {item.attended_by && (
                                            <p><span>Attended by:</span> {item.attended_by}</p>
                                        )}
                                    </div>
                                </Grid>
                            ))}


                        </Grid>)}

                    </Box>
                )
                }

            </Container>
            <ToastContainer />
        </Layout >
    );
};

export default CurrentBreakdown;
